<template>
  <div class="notification is-danger">
    <button class="button is-small is-light" @click.prevent="$emit('error:reload')">
       <span class="icon" v-if="isLoading">
           <i class="fas fa-spinner fa-spin"></i>
        </span> 
      <span class="icon" v-else>
        <i class="fas fa-redo"> </i>
      </span>
    </button>
    <p>
      {{ __("labels.error.loading") }}
    </p>
  </div>
</template>
<script>
export default {
  props: {
      isLoading : {
          type : Boolean,
          default: false,
      }
    },
  data() {
    return {};
  },
};
</script>
<style scoped>
</style>